import {Button, Form, Input, Modal, Select} from 'antd';
import Password from 'antd/es/input/Password';
import {useState} from 'react';

import {useAdminCreateUserMutation} from '../../../../gen/api/apis';
import {SunshineInternalDtoAdminUsersUserRole} from '../../../../gen/api/models';
import {useNotification} from '../../../../NotificationContext';

export interface CreateUserDialogProps {
    onCreated: () => void;
}

export const CreateUserDialog = (props: CreateUserDialogProps) => {
    const notify = useNotification();
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();

    const createUser = useAdminCreateUserMutation({
        onSuccess: () => {
            form.resetFields();
            notify.openNotificationWithIcon('success', 'User created');
            setVisible(false);
            props.onCreated();
        },
    });

    const submit = () => {
        form.validateFields().then((values) => {
            createUser.mutate({
                user: {
                    email: values.email,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    password: values.password,
                    role: values.role,
                },
            });
            console.log(values);
        });
    };
    return (
        <div>
            <Button
                type="primary"
                onClick={() => setVisible(true)}
            >
                Create User
            </Button>
            <Modal
                open={visible}
                onCancel={() => setVisible(false)}
                onOk={submit}
                title="Create User"
            >
                <Form
                    layout="horizontal"
                    labelCol={{span: 5}}
                    wrapperCol={{span: 19}}
                    preserve={false}
                    form={form}
                    onFinish={(values) => {
                        console.log(values);
                    }}
                >
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[{required: true, message: 'Please input an email!'}]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="firstName"
                        label="First Name"
                        rules={[{required: true, message: 'Please input a first name!'}]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="lastName"
                        label="Last Name"
                        rules={[{required: true, message: 'Please input a last name!'}]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[{required: true, message: 'Please input a password!'}]}
                    >
                        <Password />
                    </Form.Item>

                    <Form.Item
                        name="role"
                        label="Role"
                        rules={[{required: true, message: 'Please input a role!'}]}
                    >
                        <Select defaultValue={SunshineInternalDtoAdminUsersUserRole.RoleUser}>
                            <Select.Option
                                key={SunshineInternalDtoAdminUsersUserRole.RoleUser}
                                value={SunshineInternalDtoAdminUsersUserRole.RoleUser}
                            >
                                Default User
                            </Select.Option>
                            <Select.Option
                                key={SunshineInternalDtoAdminUsersUserRole.RoleAdmin}
                                value={SunshineInternalDtoAdminUsersUserRole.RoleAdmin}
                            >
                                Admin
                            </Select.Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
